module.exports = __webpack_public_path__ + "static/media/SystemTopology.1ff8c2ae.jpg";